import { Input, message, Modal, Select, DatePicker } from "antd";
import { Form } from "antd";
import React, { useContext, useEffect } from "react";
import dayjs from 'dayjs';
import apiService from "../../../services/apiServices";
import { AuthContext } from "../../../context/auth-context/AuthContext";

const ModalEditar = ({ open, setOpen, setRefreshTable, data, handleLogout }) => {
  const [form] = Form.useForm();
  const { handleRefreshToken } = useContext(AuthContext);
  const {logout, authState} = useContext(AuthContext);

  const handleSubmitEdition = async () => {
    const formValues = form.getFieldsValue();
    // console.log(
    //   "%c DATA PARA ENVIAR A LA PETICION HTTTP",
    //   "color: #00ff00",
    //   formValues
    // );
    try {
      const tokenVerified = await handleRefreshToken();
      const res = await apiService.editUser(data.id, formValues, tokenVerified);
      if (!res.ok && res.error) {
        message.error(res.error || "Error al crear el usuario");
        return false;
      }
      
      console.log("%c DATA DE LA RESPUESTA AL MODIFICAR UN USUARIO", "color: #00ff00", res);
      if(res.id === authState.userId && res.role !== authState.role){        
        handleLogout();
      }else{
        setRefreshTable((prev) => !prev);
      }
      setOpen(false);      
      return true;
    } catch (error) {
      console.error("%c ERROR EN EDICION DE USUARIO", "color: red", error);
      message.error("Error al editar el usuario");
      return false;
    }
    // handleSave(formValues);
  };
  useEffect(() => {
    if (data) {
      const dateTime = new Date(data.subscriptionEndDate);
      const dateformatted = dateTime.toLocaleDateString("en-CA"); // Formato ISO (YYYY-MM-DD)
      //console.log(dateformatted); // Salida: 2025-04-15

      const formattedData = {
        ...data,
        subscriptionEndDate: data.subscriptionEndDate
          ? dayjs(data.subscriptionEndDate)
          : null,
      };
      //console.log("%c DATA FORMATEADA", "color: #00ff00", formattedData);      
      form.setFieldsValue(formattedData);
    }
  }, [data, form]);

  return (
    <>
      <Modal
        title="Editar Usuario"
        open={open}
        onCancel={() => setOpen(false)}
        onOk={handleSubmitEdition}
        okText="Guardar"
        cancelText="Cancelar"
      >
        <Form form={form} layout="vertical">
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)",
              gap: "16px",
            }}
          >
            <Form.Item
              name="firstName"
              label="Nombre"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="lastName"
              label="Apellido"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="username"
              label="Usuario"
              rules={[{ required: true }]}
            >
              <Input disabled />
            </Form.Item>
            <Form.Item name="email" label="Correo" rules={[{ required: true }]}>
              <Input disabled />
            </Form.Item>
            <Form.Item name="role" label="Rol" rules={[{ required: true }]}>
              <Select>
                <Select.Option value="ADMIN">Administrador</Select.Option>
                <Select.Option value="SUPER_ADMIN">Super Admin</Select.Option>
                <Select.Option value="USER">User</Select.Option>
              </Select>
            </Form.Item>
            <Form.Item name="subscription" label="Suscripción">
              <Select>
                <Select.Option value="free">Freemium</Select.Option>
                <Select.Option value="mensual">Mensual</Select.Option>
                <Select.Option value="anual">Anual</Select.Option>
              </Select>
            </Form.Item>
            <Form.Item name="subscriptionStatus" label="Estado Suscripción">
              <Select>
                <Select.Option value="active">Activo</Select.Option>
                <Select.Option value="pending">Pendiente</Select.Option>
                <Select.Option value="suspend">Suspendido</Select.Option>
                <Select.Option value="cancel">Cancelado</Select.Option>
              </Select>
            </Form.Item>
            <Form.Item name="subscriptionEndDate" label="Fecha Fin Suscripción">
              <DatePicker
                //format="DD/MM/YYYY"
                style={{ width: "100%", borderColor: "#4CAF50" }}
              />
            </Form.Item>

            <Form.Item name="plan" label="Plan">
              <Select>
                <Select.Option value="starter">Starter</Select.Option>
                <Select.Option value="professional">Professional</Select.Option>
                <Select.Option value="corporate">Corporate</Select.Option>
              </Select>
            </Form.Item>
            {/* <Form.Item name="isActive" label="Activo">
                 <Select>
                   <Select.Option value={true}>Sí</Select.Option>
                   <Select.Option value={false}>No</Select.Option>
                 </Select>
               </Form.Item> */}
            {/* <Form.Item name="experienceCount" label="Experiencias Creadas">
                 <Input type="number" />
               </Form.Item> */}
            <Form.Item name="experienceLimit" label="Límite de Experiencias">
              <Input type="number" />
            </Form.Item>
                   <Form.Item
                          name="password"
                          label="Contraseña"
                          rules={[
                            { required: true, message: "Por favor ingrese la contraseña" },
                            {
                              min: 8,
                              message: "La contraseña debe tener al menos 8 caracteres",
                            },
                            {
                              pattern: /^(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.{8,})/,
                              message:
                                "La contraseña debe contener al menos una mayúscula y un símbolo (!@#$%^&*)",
                            },
                          ]}
                        >
                          <Input.Password />
                        </Form.Item>
                        <Form.Item
                          name="confirmPassword"
                          label="Confirmar Contraseña"
                          dependencies={['password']}
                          rules={[
                            { required: true, message: "Por favor confirme la contraseña" },
                            ({ getFieldValue }) => ({
                              validator(_, value) {
                                if (!value || getFieldValue('password') === value) {
                                  return Promise.resolve();
                                }
                                return Promise.reject(new Error('Las contraseñas no coinciden'));
                              },
                            }),
                            ]}
                          >
                            <Input.Password />
                          </Form.Item>
          </div>
        </Form>
      </Modal>
    </>
  );
};

export default ModalEditar;
